import React from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './main.css';

import {
    Modal,
    Icon,
    ModalContent
} from "semantic-ui-react";

import pc from './images/Aussie Page - 2.png';

function Section6() {
    AOS.init();
    return (
        <section className="australia-council-section6-container">
            <div className="ac-section6-paragraph1">
                <h2 data-aos="fade-down" data-aos-duration="2000" data-aos-once="true">Ziplyne is here to help!</h2>
                <p data-aos="fade-down" data-aos-delay="100" data-aos-duration="2000" data-aos-once="true">Ziplyne is a SaaS based solution that sits on top of your website or web application to onboard, train, support and guide your users through any digital business process</p>
                <Modal
                    className="seeactionmodal"
                    trigger={
                        <button className="australia-council-section6-container" data-aos="fade-up-right" data-aos-delay="100" data-aos-duration="2000" data-aos-once="true">
                            <Icon name={"play"} />View Ziplyne In Action
                        </button>
                    }>
                    <ModalContent>
                        <iframe
                            className="vimeovid"
                            src="https://player.vimeo.com/video/448328124"
                            frameborder="0"
                            allow="autoplay; fullscreen"
                            allowfullscreen
                            title="Ziplyne on a Council"
                        ></iframe>
                    </ModalContent>
                </Modal>
            </div>

            <div className="ac-section6-paragraph2">
                <img data-aos="fade-right" data-aos-delay="300" data-aos-duration="2000" data-aos-once="true" src={pc} style={{ width: "140%", height: "70%" }} alt="" className="ac-section6-image-pc" />
            </div>
        </section>
    )
}

export default Section6
